import { CategoryCardFilter } from './category-card-filter'
import { ProductCard } from './product-card'

export const SideSection = (target: HTMLAnchorElement) => {
  let apiUrl = `/umbraco/api/product/Crossell`
  const el = {
    link: target,
    sidesection: document.querySelector<HTMLDivElement>('.sidesection'),
    bcsidesection: document.querySelector<HTMLDivElement>('.bcsidesection'),
    container: document.querySelector<HTMLDivElement>('.sidesection .grid--products'),
    //manufacturerFilter: document.querySelector<HTMLSelectElement>( //TODO add manufacturer filter again
    //  '.sidesection #search-manufacturer'
    //),
  }

  if (el.bcsidesection) {
    apiUrl = `/umbraco/api/product/bcCrossell`
  }

  const categoryID = el.link.dataset ? el.link.dataset.category : null

  const method = {
    init: () => {
      if (!el.link) return
      el.link.addEventListener('click', method.fetchMarkup)
      document.addEventListener('click', method.isClickInside)
    },

    fetchMarkup: async (e: Event & { target: HTMLInputElement }) => {
      e.preventDefault()
      e.stopPropagation()

      try {
        const queryString = window.location.search
        const urlParams = new URLSearchParams(queryString)
        let sku = urlParams ? urlParams.get('sku') : e.target?.dataset?.sku

        const category = e.target.closest('a').getAttribute('data-category')

        sku = sku === null ? document.getElementById('product-sku').innerHTML : sku

        const response = await fetch(`${apiUrl}?sku=${sku}&categoryId=${category}`)
        const data = await response.json()

        if (!data) {
          throw Error('')
        }

        const newMarkup = document.createElement('div')
        newMarkup.innerHTML = data

        if (categoryID) {
          //const filteredItems =
          //  newMarkup.querySelectorAll<HTMLDivElement>('.product-card')

          //filteredItems.forEach((item) => {
          //  if (item.dataset.category !== categoryID) {
          //    item.parentNode.removeChild(item)
          //  }
          //})

          //// repopulate manufacturers select dropdown
          //const manufacturers = []

          //newMarkup.querySelectorAll<HTMLDivElement>('.product-card').forEach((item) => {
          //  const manufacturer = item.dataset.manufacturer
          //  manufacturers.push(manufacturer)
          //})

          ////const options =
          ////  el.manufacturerFilter.querySelectorAll<HTMLOptionElement>('option')

          //options.forEach((element) => {
          //  if (element.value) {
          //    element.remove()
          //  }
          //})

          //const unique = manufacturers.filter(
          //  (value, index, array) => array.indexOf(value) === index
          //)

          //unique.forEach((manufacturer) => {
          //  const newOption = document.createElement('option')
          //  newOption.value = manufacturer
          //  newOption.text = manufacturer
          //  newOption.className = 'select__option'
          //  el.manufacturerFilter.appendChild(newOption)
          //})

          el.container.innerHTML = newMarkup.innerHTML

          const newProductCards =
            el.container.querySelectorAll<HTMLDivElement>('.product-card')
          newProductCards.forEach((productCard) => {
            ProductCard(productCard)
          })
        }
      } catch (e) {
        console.log(e)
        el.container.innerHTML =
          '<div class="filter-message span-grid-12">Engar vörur fundust</div>'
      }
      method.toggleSideSection()
    },
    toggleSideSection: () => {
      if (!el.sidesection.classList.contains('sidesection--open')) {
        el.sidesection.classList.add('sidesection--open')

        CategoryCardFilter(el.sidesection)
      } else {
        el.sidesection.classList.remove('sidesection--open')
      }
    },
    isOpen: () => el.sidesection.classList.contains('sidesection--open'),
    isClickInside: (e) => {
      const isClickInside = el.sidesection && el.sidesection.contains(e.target)

      if (!isClickInside && method.isOpen()) {
        e.preventDefault()
        e.stopPropagation()
        el.sidesection.classList.remove('sidesection--open')
      }
    },
  }

  method.init()
}
